import stores from "./agences"

const agences = stores.map(name => ({"tag": "option", "cf-label": name, "value": name }))

export default [
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_rejet_carte",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_rejet_carte",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_rejet_carte",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_rejet_carte",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_rejet_carte",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_rejet_carte",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_rejet_carte",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_rejet_carte",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_rejet_carte_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_rejet_carte",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_rejet_carte_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-sub_reason": "sub_reason_probleme_de_connexion",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_probleme_de_connexion",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_probleme_de_connexion",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_probleme_de_connexion",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_probleme_de_connexion",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_probleme_de_connexion",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_probleme_de_connexion",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_probleme_de_connexion",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_probleme_de_connexion_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_probleme_de_connexion",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_probleme_de_connexion_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_probleme_de_batterie",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_probleme_de_batterie",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_probleme_de_batterie",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_probleme_de_batterie",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_probleme_de_batterie",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_probleme_de_batterie",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_probleme_de_batterie",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_probleme_de_batterie",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_probleme_de_batterie_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_probleme_de_batterie",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_probleme_de_batterie_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-sub_reason": "sub_reason_acces_impossible",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_acces_impossible",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_acces_impossible",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_acces_impossible",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_acces_impossible",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_acces_impossible",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_acces_impossible",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_acces_impossible",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_acces_impossible_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_acces_impossible",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_acces_impossible_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-sub_reason": "sub_reason_pay_secure",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_pay_secure",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_pay_secure",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_pay_secure",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_pay_secure",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_pay_secure",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_pay_secure",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_pay_secure",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_pay_secure_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_pay_secure",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_pay_secure_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  /*
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-sub_reason": "sub_reason_transaction_non_percue",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_transaction_non_percue",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_transaction_non_percue",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_transaction_non_percue",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_transaction_non_percue",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_transaction_non_percue",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_transaction_non_percue",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_transaction_non_percue",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_rejet_transaction_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_transaction_non_percue",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_rejet_transaction_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },*/
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-sub_reason": "sub_reason_notification_sms",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_notification_sms",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_notification_sms",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_notification_sms",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_notification_sms",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_notification_sms",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_notification_sms",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_notification_sms",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_echec_reception_notification_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_notification_sms",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_echec_reception_notification_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-sub_reason": "sub_reason_echec_reception_notification",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_echec_reception_notification",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_echec_reception_notification",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_echec_reception_notification",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_echec_reception_notification",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_echec_reception_notification",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_echec_reception_notification",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_echec_reception_notification",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_echec_reception_notification_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_echec_reception_notification",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_echec_reception_notification_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-objet": "subject_autres",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-objet": "subject_autres",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-objet": "subject_autres",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-objet": "subject_autres",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-objet": "subject_autres",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-objet": "subject_autres",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-objet": "subject_autres",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-objet": "subject_autres",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'subject_autres_forFinishStep',
      "cf-conditional-objet": "subject_autres",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-subject_autres_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_activation",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_activation",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_activation",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_activation",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_activation",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_activation",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_activation",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_activation",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_activation_forFinishStep',
      "cf-conditional-reason_need": "reason_need_activation",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_activation_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_desactivation",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_desactivation",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_desactivation",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_desactivation",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_desactivation",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_desactivation",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_desactivation",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_desactivation",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_desactivation_forFinishStep',
      "cf-conditional-reason_need": "reason_need_desactivation",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_desactivation_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_mise_en_opposition",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_mise_en_opposition",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_mise_en_opposition",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_mise_en_opposition",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_mise_en_opposition",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_mise_en_opposition",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_mise_en_opposition",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_mise_en_opposition",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_mise_en_opposition_forFinishStep',
      "cf-conditional-reason_need": "reason_need_mise_en_opposition",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_mise_en_opposition_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_reactivation",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_reactivation",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_reactivation",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_reactivation",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_reactivation",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_reactivation",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_reactivation",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_reactivation",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_reactivation_forFinishStep',
      "cf-conditional-reason_need": "reason_need_reactivation",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_reactivation_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_rechargement",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_rechargement",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_rechargement",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_rechargement",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_rechargement",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_rechargement",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_rechargement",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_rechargement",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_rechargement_forFinishStep',
      "cf-conditional-reason_need": "reason_need_rechargement",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_rechargement_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_transfert_de_solde",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_transfert_de_solde",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_transfert_de_solde",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_transfert_de_solde",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_transfert_de_solde",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_transfert_de_solde",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_transfert_de_solde",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_transfert_de_solde",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_transfert_de_solde_forFinishStep',
      "cf-conditional-reason_need": "reason_need_transfert_de_solde",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_transfert_de_solde_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_demande_releve",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_demande_releve",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_demande_releve",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_demande_releve",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_demande_releve",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_demande_releve",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_demande_releve",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_demande_releve",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_demande_releve_forFinishStep',
      "cf-conditional-reason_need": "reason_need_demande_releve",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_demande_releve_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_changement_de_compte",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_changement_de_compte",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_changement_de_compte",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_changement_de_compte",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_changement_de_compte",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_changement_de_compte",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_changement_de_compte",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_changement_de_compte",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_changement_de_compte_forFinishStep',
      "cf-conditional-reason_need": "reason_need_changement_de_compte",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_changement_de_compte_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_changement_n0_tel",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_changement_n0_tel",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_changement_n0_tel",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_changement_n0_tel",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_changement_n0_tel",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_changement_n0_tel",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_changement_n0_tel",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_changement_n0_tel",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_changement_n0_tel_forFinishStep',
      "cf-conditional-reason_need": "reason_need_changement_n0_tel",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_changement_n0_tel_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_changement_n0tel",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_changement_n0tel",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_changement_n0tel",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_changement_n0tel",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_changement_n0tel",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_changement_n0tel",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_changement_n0tel",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_changement_n0tel",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_changement_n0tel_forFinishStep',
      "cf-conditional-reason_need": "reason_need_changement_n0tel",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_changement_n0tel_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_enrolement_3d_secure",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_enrolement_3d_secure",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_enrolement_3d_secure",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_enrolement_3d_secure",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_enrolement_3d_secure",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_enrolement_3d_secure",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_enrolement_3d_secure",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_enrolement_3d_secure",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_enrolement_3d_secure_forFinishStep',
      "cf-conditional-reason_need": "reason_need_enrolement_3d_secure",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_enrolement_3d_secure_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_modification_plafond",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_modification_plafond",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_modification_plafond",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_modification_plafond",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_modification_plafond",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_modification_plafond",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_modification_plafond",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_modification_plafond",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_modification_plafond_forFinishStep',
      "cf-conditional-reason_need": "reason_need_modification_plafond",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_modification_plafond_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_emission_nouveau_code_pin",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_emission_nouveau_code_pin",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_emission_nouveau_code_pin",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_emission_nouveau_code_pin",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_emission_nouveau_code_pin",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_emission_nouveau_code_pin",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_emission_nouveau_code_pin",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_emission_nouveau_code_pin",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_emission_nouveau_code_pin_forFinishStep',
      "cf-conditional-reason_need": "reason_need_emission_nouveau_code_pin",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_emission_nouveau_code_pin_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_paiement_facture",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_paiement_facture",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_paiement_facture",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_paiement_facture",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_paiement_facture",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_paiement_facture",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_paiement_facture",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_paiement_facture",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_paiement_facture_forFinishStep',
      "cf-conditional-reason_need": "reason_need_paiement_facture",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_paiement_facture_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_changement_modalites_de_remboursement",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_changement_modalites_de_remboursement",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_changement_modalites_de_remboursement",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_changement_modalites_de_remboursement",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_changement_modalités_remboursement",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_changement_modalites_de_remboursement",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_changement_modalites_de_remboursement",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_changement_modalites_de_remboursement",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_changement_modalites_remboursement_forFinishStep',
      "cf-conditional-reason_need": "reason_need_changement_modalites_de_remboursement",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_changement_modalites_remboursement_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_nouvelle_carte",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_nouvelle_carte",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_nouvelle_carte",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_nouvelle_carte",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_nouvelle_carte",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_nouvelle_carte",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_nouvelle_carte",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_nouvelle_carte",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_nouvelle_carte_forFinishStep',
      "cf-conditional-reason_need": "reason_need_nouvelle_carte",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_nouvelle_carte_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_renouvellement",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_renouvellement",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_renouvellement",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_renouvellement",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_renouvellement",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_renouvellement",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_renouvellement",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_renouvellement",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_renouvellement_de_carte_forFinishStep',
      "cf-conditional-reason_need": "reason_need_renouvellement",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_renouvellement_de_carte_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_remplacement",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_remplacement",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_remplacement",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_remplacement",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_remplacement",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_remplacement",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_remplacement",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_remplacement",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_remplacement_de_carte_forFinishStep',
      "cf-conditional-reason_need": "reason_need_remplacement",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_remplacement_de_carte_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason": "reason_rouleau",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason": "reason_rouleau",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason": "reason_rouleau",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason": "reason_rouleau",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason": "reason_rouleau",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason": "reason_rouleau",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason": "reason_rouleau",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason": "reason_rouleau",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_rouleau_forFinishStep',
      "cf-conditional-reason_need": "reason_rouleau",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_rouleau_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason": "reason_chargeur",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason": "reason_chargeur",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason": "reason_chargeur",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason": "reason_chargeur",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason": "reason_chargeur",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason": "reason_chargeur",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason": "reason_chargeur",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason": "reason_chargeur",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_chargeur_forFinishStep',
      "cf-conditional-reason_need": "reason_chargeur",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_chargeur_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason": "reason_tpe_additionnel",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason": "reason_tpe_additionnel",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason": "reason_tpe_additionnel",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason": "reason_tpe_additionnel",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason": "reason_tpe_additionnel",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason": "reason_tpe_additionnel",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason": "reason_tpe_additionnel",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason": "reason_tpe_additionnel",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_tpe_additionnel_forFinishStep',
      "cf-conditional-reason": "reason_tpe_additionnel",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_tpe_additionnel_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason": "reason_fonction_additionnelle",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason": "reason_fonction_additionnelle",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason": "reason_fonction_additionnelle",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason": "reason_fonction_additionnelle",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason": "reason_fonction_additionnelle",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason": "reason_fonction_additionnelle",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason": "reason_fonction_additionnelle",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason": "reason_fonction_additionnelle",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_fonction_additionnelle_forFinishStep',
      "cf-conditional-reason_need": "reason_fonction_additionnelle",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_fonction_additionnelle_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-sub_reason": "sub_reason_reinitialisation",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_reinitialisation",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_reinitialisation",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_reinitialisation",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_reinitialisation",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_reinitialisation",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_reinitialisation",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_reinitialisation",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_reinitialisation_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_reinitialisation",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_reinitialisation_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-sub_reason": "sub_reason_credit_access",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_credit_access",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_credit_access",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_credit_access",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_credit_access",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_credit_access",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_credit_access",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_credit_access",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_credit_access_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_credit_access",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_credit_access_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-sub_reason": "sub_reason_ajout_nouvel_utilisateur",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_ajout_nouvel_utilisateur",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_ajout_nouvel_utilisateur",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_ajout_nouvel_utilisateur",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_ajout_nouvel_utilisateur",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_ajout_nouvel_utilisateur",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_ajout_nouvel_utilisateur",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_ajout_nouvel_utilisateur",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_ajout_nouvel_utilisateur_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_ajout_nouvel_utilisateur",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_ajout_nouvel_utilisateur_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-sub_reason": "sub_reason_modification_profil",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_modification_profil",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_modification_profil",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_modification_profil",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_modification_profil",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_modification_profil",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_modification_profil",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_modification_profil",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_modification_profil_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_modification_profil",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_modification_profil_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-sub_reason": "sub_reason_creation_acces",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_creation_acces",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_creation_acces",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_creation_acces",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_creation_acces",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_creation_acces",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_creation_acces",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_creation_acces",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_creation_acces_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_creation_acces",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_creation_acces_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason": "reason_autres",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason": "reason_autres",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason": "reason_autres",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason": "reason_autres",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason": "reason_autres",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason": "reason_autres",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason": "reason_autres",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason": "reason_autres",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_autres_forFinishStep',
      "cf-conditional-reason": "reason_autres",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_autres_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_billet_cassette_vide",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_billet_cassette_vide",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_billet_cassette_vide",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_billet_cassette_vide",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_billet_cassette_vide",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_billet_cassette_vide",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_billet_cassette_vide",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_billet_cassette_vide",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_billet_cassette_vide_forFinishStep',
      "cf-conditional-reason_need": "reason_need_billet_cassette_vide",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_billet_cassette_vide_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_reseau",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_reseau",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_reseau",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_reseau",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_reseau",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_reseau",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_reseau",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_reseau",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_reseau_forFinishStep',
      "cf-conditional-reason_need": "reason_need_reseau",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_reseau_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_bourrage",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_bourrage",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_bourrage",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_bourrage",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_bourrage",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_bourrage",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_bourrage",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_bourrage",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_bourrage_forFinishStep',
      "cf-conditional-reason_need": "reason_need_bourrage",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_bourrage_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_pb_batterie",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_pb_batterie",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_pb_batterie",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_pb_batterie",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_pb_batterie",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_pb_batterie",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_pb_batterie",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_pb_batterie",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_pb_batterie_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_pb_batterie",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_pb_batterie_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_pepele",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_pepele",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_pepele",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_pepele",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_pepele",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_pepele",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_pepele",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_pepele",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_pepele_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_pepele",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_pepele_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_echec_de_transfert",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_echec_de_transfert",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_echec_de_transfert",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_echec_de_transfert",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_echec_de_transfert",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_echec_de_transfert",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_echec_de_transfert",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_echec_de_transfert",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_echec_de_transfert_forFinishStep',
      "cf-conditional-reason_need": "reason_need_echec_de_transfert",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_echec_de_transfert_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_echec_de_connexion_a_netbank",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_echec_de_connexion_a_netbank",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_echec_de_connexion_a_netbank",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_echec_de_connexion_a_netbank",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_echec_de_connexion_a_netbank",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_echec_de_connexion_a_netbank",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_echec_de_connexion_a_netbank",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_echec_de_connexion_a_netbank",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_echec_de_connexion_a_netbank_forFinishStep',
      "cf-conditional-reason_need": "reason_need_echec_de_connexion_a_netbank",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_echec_de_connexion_a_netbank_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-reason_need": "reason_need_code_swift_inexistant",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_code_swift_inexistant",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_code_swift_inexistant",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_code_swift_inexistant",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_code_swift_inexistant",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_code_swift_inexistant",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_code_swift_inexistant",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_code_swift_inexistant",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_code_swift_inexistant_forFinishStep',
      "cf-conditional-reason_need": "reason_need_code_swift_inexistant",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_code_swift_inexistant_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_rejet_technique",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_rejet_technique",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_rejet_technique",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_rejet_technique",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_rejet_technique",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_rejet_technique",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_rejet_technique",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_rejet_technique",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_rejet_technique_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_rejet_technique",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_rejet_technique_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
    'tag': 'input',
    'type': 'text',
    'name': 'lastname',
    "cf-conditional-sub_reason": "sub_reason_demande_de_liaison_de_compte_pepele_mobile_et_banque",
    'cf-questions': 'Veuillez saisir votre nom',
    'cf-input-placeholder': 'Entrez votre réponse ici...',
    'cf-validation': 'required',
    'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_demande_de_liaison_de_compte_pepele_mobile_et_banque",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_demande_de_liaison_de_compte_pepele_mobile_et_banque",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_demande_de_liaison_de_compte_pepele_mobile_et_banque",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_demande_de_liaison_de_compte_pepele_mobile_et_banque",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_demande_de_liaison_de_compte_pepele_mobile_et_banque",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_demande_de_liaison_de_compte_pepele_mobile_et_banque",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_demande_de_liaison_de_compte_pepele_mobile_et_banque",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_demande_de_liaison_de_compte_pepele_mobile_et_banque_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_demande_de_liaison_de_compte_pepele_mobile_et_banque",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_demande_de_liaison_de_compte_pepele_mobile_et_banque_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_demande_du_message_swift_sur_transfert_domestique_et_international",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_demande_du_message_swift_sur_transfert_domestique_et_international",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_demande_du_message_swift_sur_transfert_domestique_et_international",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_demande_du_message_swift_sur_transfert_domestique_et_international",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_demande_du_message_swift_sur_transfert_domestique_et_international",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_demande_du_message_swift_sur_transfert_domestique_et_international",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_demande_du_message_swift_sur_transfert_domestique_et_international",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_demande_du_message_swift_sur_transfert_domestique_et_international",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_demande_du_message_swift_sur_transfert_domestique_et_international_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_demande_du_message_swift_sur_transfert_domestique_et_international",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_demande_du_message_swift_sur_transfert_domestique_et_international_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_deblocage_compte",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_deblocage_compte",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_deblocage_compte",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_deblocage_compte",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_deblocage_compte",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_deblocage_compte",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_deblocage_compte",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_deblocage_compte",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_deblocage_compte_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_deblocage_compte",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_deblocage_compte_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_cloture_compte",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_cloture_compte",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_cloture_compte",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_cloture_compte",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_cloture_compte",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_cloture_compte",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_cloture_compte",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_cloture_compte",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_cloture_compte_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_cloture_compte",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_cloture_compte_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_credit_pepele_mobile",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_credit_pepele_mobile",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_credit_pepele_mobile",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_credit_pepele_mobile",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_credit_pepele_mobile",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_credit_pepele_mobile",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_credit_pepele_mobile",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_credit_pepele_mobile",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_credit_pepele_mobile_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_credit_pepele_mobile",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_credit_pepele_mobile_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_carte_pepele_mobile",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_carte_pepele_mobile",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_carte_pepele_mobile",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_carte_pepele_mobile",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_carte_pepele_mobile",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_carte_pepele_mobile",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_carte_pepele_mobile",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_carte_pepele_mobile",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_carte_pepele_mobile_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_carte_pepele_mobile",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_carte_pepele_mobile_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_ouverture_compte_pplm",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_ouverture_compte_pplm",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_ouverture_compte_pplm",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_ouverture_compte_pplm",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_ouverture_compte_pplm",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_ouverture_compte_pplm",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_ouverture_compte_pplm",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_ouverture_compte_pplm",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_ouverture_compte_pplm_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_ouverture_compte_pplm",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_ouverture_compte_pplm_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_depot___retrait",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_depot___retrait",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_depot___retrait",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_depot___retrait",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_depot___retrait",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_depot___retrait",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_depot___retrait",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_depot___retrait",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_depot___retrait_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_depot___retrait",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_depot___retrait_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_frais_plateforme_pplm",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_frais_plateforme_pplm",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_frais_plateforme_pplm",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_frais_plateforme_pplm",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_frais_plateforme_pplm",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_frais_plateforme_pplm",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_frais_plateforme_pplm",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_frais_plateforme_pplm",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_frais_plateforme_pplm_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_frais_plateforme_pplm",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_frais_plateforme_pplm_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_echec_retrait_atm",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_echec_retrait_atm",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_echec_retrait_atm",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_echec_retrait_atm",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_echec_retrait_atm",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_echec_retrait_atm",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_echec_retrait_atm",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_echec_retrait_atm",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_echec_retrait_atm_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_echec_retrait_atm",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_echec_retrait_atm_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_paiement_marchand",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_paiement_marchand",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_paiement_marchand",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_paiement_marchand",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_paiement_marchand",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_paiement_marchand",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_paiement_marchand",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_paiement_marchand",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_paiement_marchand_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_paiement_marchand",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_paiement_marchand_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_paiement_facture",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_paiement_facture",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_paiement_facture",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_paiement_facture",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_paiement_facture",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_paiement_facture",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_paiement_facture",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_paiement_facture",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_paiement_facture_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_paiement_facture",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_paiement_facture_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_releve_compte",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_releve_compte",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_releve_compte",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_releve_compte",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_releve_compte",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_releve_compte",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_releve_compte",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_releve_compte",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_releve_compte_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_releve_compte",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_releve_compte_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_devenir_ai__agent_independant_",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_devenir_ai__agent_independant_",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_devenir_ai__agent_independant_",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_devenir_ai__agent_independant_",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_devenir_ai__agent_independant_",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_devenir_ai__agent_independant_",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_devenir_ai__agent_independant_",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_devenir_ai__agent_independant_",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_devenir_ai__agent_independant__forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_devenir_ai__agent_independant_",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_devenir_ai__agent_independant__forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_operation_non_aboutie",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_operation_non_aboutie",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_operation_non_aboutie",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_operation_non_aboutie",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_operation_non_aboutie",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_operation_non_aboutie",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_operation_non_aboutie",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_operation_non_aboutie",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_operation_non_aboutie_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_operation_non_aboutie",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_operation_non_aboutie_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_transfert_cash",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_transfert_cash",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_transfert_cash",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_transfert_cash",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_transfert_cash",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_transfert_cash",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_transfert_cash",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_transfert_cash",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_transfert_cash_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_transfert_cash",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_transfert_cash_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_transfert_compte",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_transfert_compte",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_transfert_compte",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_transfert_compte",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_transfert_compte",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_transfert_compte",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_transfert_compte",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_transfert_compte",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'sub_reason_transfert_compte_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_transfert_compte",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-sub_reason_transfert_compte_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-objet": "objet_autres",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-objet": "objet_autres",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-objet": "objet_autres",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-objet": "objet_autres",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-objet": "objet_autres",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-objet": "objet_autres",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-objet": "objet_autres",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-objet": "objet_autres",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'objet_autres_forFinishStep',
      "cf-conditional-objet": "objet_autres",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-objet_autres_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_echec_de_paiement_facture_pepele",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_echec_de_paiement_facture_pepele",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_echec_de_paiement_facture_pepele",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_echec_de_paiement_facture_pepele",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_echec_de_paiement_facture_pepele",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_echec_de_paiement_facture_pepele",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_echec_de_paiement_facture_pepele",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_echec_de_paiement_facture_pepele",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_echec_de_paiement_facture_pepele_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_echec_de_paiement_facture_pepele",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_echec_de_paiement_facture_pepele_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_echec_de_changement_d_offre",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_echec_de_changement_d_offre",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_echec_de_changement_d_offre",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_echec_de_changement_d_offre",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_echec_de_changement_d_offre",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_echec_de_changement_d_offre",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_echec_de_changement_d_offre",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_echec_de_changement_d_offre",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_echec_de_changement_d_offre_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_echec_de_changement_d_offre",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_echec_de_changement_d_offre_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_commission_pepele_non_percue",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_commission_pepele_non_percue",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_commission_pepele_non_percue",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_commission_pepele_non_percue",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_commission_pepele_non_percue",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_commission_pepele_non_percue",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_commission_pepele_non_percue",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_commission_pepele_non_percue",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_commission_pepele_non_percue_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_commission_pepele_non_percue",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_commission_pepele_non_percue_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  /////////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-reason_need": "reason_need_tp1600",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_tp1600",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_tp1600",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_tp1600",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_tp1600",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_tp1600",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_tp1600",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_tp1600",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_tp1600_forFinishStep',
      "cf-conditional-reason_need": "reason_need_tp1600",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_tp1600_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
     ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-reason_need": "reason_need_atm",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-reason_need": "reason_need_atm",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-reason_need": "reason_need_atm",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-reason_need": "reason_need_atm",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-reason_need": "reason_need_atm",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-reason_need": "reason_need_atm",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-reason_need": "reason_need_atm",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-reason_need": "reason_need_atm",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_need_atm_forFinishStep',
      "cf-conditional-reason_need": "reason_need_atm",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_need_atm_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_devenir_marchand",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_devenir_marchand",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_devenir_marchand",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_devenir_marchand",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_devenir_marchand",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_devenir_marchand",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_devenir_marchand",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_devenir_marchand",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_devenir_marchand_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_devenir_marchand",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_devenir_marchand_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
   ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_approvisionnement_compte",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_approvisionnement_compte",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_approvisionnement_compte",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_approvisionnement_compte",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_approvisionnement_compte",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_approvisionnement_compte",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_approvisionnement_compte",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_approvisionnement_compte",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_approvisionnement_compte_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_approvisionnement_compte",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_approvisionnement_compte_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
   ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_demande_de_decaissement_de_credit",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_demande_de_decaissement_de_credit",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_demande_de_decaissement_de_credit",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_demande_de_decaissement_de_credit",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_demande_de_decaissement_de_credit",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_demande_de_decaissement_de_credit",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_demande_de_decaissement_de_credit",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_demande_de_decaissement_de_credit",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_demande_de_decaissement_de_credit_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_demande_de_decaissement_de_credit",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_demande_de_decaissement_de_credit_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_reactivation_tp1600",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_reactivation_tp1600",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_reactivation_tp1600",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_reactivation_tp1600",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_reactivation_tp1600",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_reactivation_tp1600",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_reactivation_tp1600",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_reactivation_tp1600",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_reactivation_tp1600_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_reactivation_tp1600",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_reactivation_tp1600_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_blocage_tp1600",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_blocage_tp1600",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_blocage_tp1600",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_blocage_tp1600",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_blocage_tp1600",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_blocage_tp1600",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_blocage_tp1600",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_blocage_tp1600",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_blocage_tp1600_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_blocage_tp1600",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_blocage_tp1600_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_suppression_tp1600",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_suppression_tp1600",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_suppression_tp1600",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_suppression_tp1600",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_suppression_tp1600",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_suppression_tp1600",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_suppression_tp1600",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_suppression_tp1600",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_suppression_tp1600_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_suppression_tp1600",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_suppression_tp1600_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_demande_de_liquidation_credit",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_demande_de_liquidation_credit",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_demande_de_liquidation_credit",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_demande_de_liquidation_credit",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_demande_de_liquidation_credit",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_demande_de_liquidation_credit",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_demande_de_liquidation_credit",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_demande_de_liquidation_credit",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_demande_de_liquidation_credit_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_demande_de_liquidation_credit",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_demande_de_liquidation_credit_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_actualisation_du_compte",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_actualisation_du_compte",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_actualisation_du_compte",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_actualisation_du_compte",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_actualisation_du_compte",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_actualisation_du_compte",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_actualisation_du_compte",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_actualisation_du_compte",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_actualisation_du_compte_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_actualisation_du_compte",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_actualisation_du_compte_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_reinitialisation_code_secret_mot_de_passe",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_reinitialisation_code_secret_mot_de_passe",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_reinitialisation_code_secret_mot_de_passe",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_reinitialisation_code_secret_mot_de_passe",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_reinitialisation_code_secret_mot_de_passe",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_reinitialisation_code_secret_mot_de_passe",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_reinitialisation_code_secret_mot_de_passe",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_reinitialisation_code_secret_mot_de_passe",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_reinitialisation_code_secret_mot_de_passe_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_reinitialisation_code_secret_mot_de_passe",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_reinitialisation_code_secret_mot_de_passe_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_blocage_de_compte",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_blocage_de_compte",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_blocage_de_compte",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_blocage_de_compte",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_blocage_de_compte",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_blocage_de_compte",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_blocage_de_compte",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_blocage_de_compte",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_blocage_de_compte_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_blocage_de_compte",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_blocage_de_compte_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_iban",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_iban",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_iban",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_iban",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_iban",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_iban",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_iban",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_iban",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_iban_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_iban",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_iban_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////
  ///////////////////////
  {
      'tag': 'input',
      'type': 'text',
      'name': 'lastname',
      "cf-conditional-sub_reason": "sub_reason_elargissement_du_plafond",
      'cf-questions': 'Veuillez saisir votre nom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'firstname',
      "cf-conditional-sub_reason": "sub_reason_elargissement_du_plafond",
      'cf-questions': 'Veuillez saisir votre prénom',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'accountNumber',
      "cf-conditional-sub_reason": "sub_reason_elargissement_du_plafond",
      'cf-questions': 'Votre numero de compte (client TMB)',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'clientAgence',
      "cf-conditional-sub_reason": "sub_reason_elargissement_du_plafond",
      'cf-questions': "Veuillez selectionner l'agence",
      "children": agences
  },
  {
      'tag': 'input',
      'type': 'number',
      'name': 'phone',
      "cf-conditional-sub_reason": "sub_reason_elargissement_du_plafond",
      'cf-questions': 'Veuillez saisir votre numéro de téléphone',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'email',
      'name': 'email',
      "cf-conditional-sub_reason": "sub_reason_elargissement_du_plafond",
      'cf-questions': 'Veuillez saisir votre adresse mail',
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-error': 'Veuillez vérifier votre e-mail.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'details_de_la_reclamation',
      "cf-conditional-sub_reason": "sub_reason_elargissement_du_plafond",
      'cf-questions': "Veuillez fournir des détails sur la réclamation",
      'cf-input-placeholder': '(Date de l’opération, informations complémentaires…)',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'input',
      'type': 'text',
      'name': 'montant',
      "cf-conditional-sub_reason": "sub_reason_elargissement_du_plafond",
      'cf-questions': "Saisissez le montant (ou mettez RAS)",
      'cf-input-placeholder': 'Entrez votre réponse ici...',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  {
      'tag': 'select',
      'type': 'text',
      'name': 'reason_elargissement_du_plafond_forFinishStep',
      "cf-conditional-sub_reason": "sub_reason_elargissement_du_plafond",
      'cf-questions': "Avez-vous des fichiers à joindre ? ",
      "children": [
          {
              "tag": "option",
              "cf-label": "Oui",
              "value": "tmb_bot_upload_file_yes",
          },
          {
              "tag": "option",
              "cf-label": "Non",
              "value": "upload_file_no",
          },
      ]
  },
  {
      'tag': 'input',
      'type': 'file',
      'multiple': true,
      'name': 'files',
      "cf-conditional-reason_elargissement_du_plafond_forFinishStep": "tmb_bot_upload_file_yes",
      'cf-questions': 'Cliquez sur le bouton ci-dessous pour ajouter les fichiers',
      'cf-validation': 'required',
      'cf-error': 'Cette information est requise.'
  },
  ///////////////////////



]
